module.exports = __webpack_public_path__ + "static/media/newsletter-woman.53420507.jpg";